import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { AdminAppProviders } from "./app/providers";
import { adminApplicationServices } from "./app/runtime";
import "@carepass/ui/styles";
import "@carepass/ui/v2/styles";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("CarePass admin-web root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <AdminAppProviders services={adminApplicationServices}>
      <App />
    </AdminAppProviders>
  </StrictMode>,
);
